import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { copied: "¡Link copiado!", share: "Compartir" },
  en: { copied: "Link copied!", share: "Share" },
});
